import { AxiosRequestConfig } from 'axios'
import { Auth as Amplify } from 'aws-amplify'
import { config as appConfig } from 'config'

const ACCEPT_LANGUAGE_HEADER = 'Accept-Language'
const DEFAULT_ACCEPTED_LANGUAGE = 'pl'
const APP_PLATFORM_HEADER = 'X-App-Platform'
const APP_PLATFORM = 'web'

export const authenticate = async (config: AxiosRequestConfig) => {
  if (config.withCredentials !== false) {
    const token = await Amplify.currentSession().then(session =>
      session.getIdToken().getJwtToken()
    )
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

export const handleSendLanguageInHeader = async (
  config: AxiosRequestConfig
) => {
  config.headers[ACCEPT_LANGUAGE_HEADER] =
    localStorage.getItem(appConfig.languageKey) || DEFAULT_ACCEPTED_LANGUAGE
  return config
}

export const handleSendAppPlatform = async (config: AxiosRequestConfig) => {
  config.headers[APP_PLATFORM_HEADER] = APP_PLATFORM
  return config
}
